import { RefObject, useEffect, useRef } from 'react';

const EMOJI_GROUPS: { label: string; emojis: string[] }[] = [
  {
    label: 'Frequentes',
    emojis: ['💡', '✅', '⚠️', '❌', '⭐', '🔥', '📎', '📝', '🚀', '✨', '👍', '👏', '🎯', '📌', '💬', '🔗'],
  },
  {
    label: 'Rosto',
    emojis: ['😀', '😊', '🙂', '🤔', '😮', '😢', '😎', '🤝'],
  },
  {
    label: 'Objetos',
    emojis: ['📁', '📂', '🗓️', '⏰', '🔔', '🛠️', '⚙️', '📊', '📈', '🖥️', '📱', '🔒'],
  },
];

type EmojiPickerProps = {
  open: boolean;
  onClose: () => void;
  onPick: (emoji: string) => void;
  anchorRef: RefObject<HTMLElement | null>;
};

export function EmojiPicker({ open, onClose, onPick, anchorRef }: EmojiPickerProps) {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;

    function onKey(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }

    function onPointer(event: MouseEvent) {
      const target = event.target as Node;
      if (panelRef.current?.contains(target)) return;
      if (anchorRef.current?.contains(target)) return;
      onClose();
    }

    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onPointer);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onPointer);
    };
  }, [open, onClose, anchorRef]);

  if (!open) return null;

  return (
    <div ref={panelRef} className="rte-emoji-picker" role="dialog" aria-label="Inserir emoji">
      {EMOJI_GROUPS.map((group) => (
        <div key={group.label} className="rte-emoji-picker__group">
          <div className="rte-emoji-picker__label">{group.label}</div>
          <div className="rte-emoji-picker__grid">
            {group.emojis.map((emoji) => (
              <button
                key={emoji}
                type="button"
                className="rte-emoji-picker__btn"
                title={emoji}
                onClick={() => {
                  onPick(emoji);
                  onClose();
                }}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
